"use strict";
import {templates} from "Subschema";
import RadioTemplateStyle from "./RadioTemplate.less";
export default {
    'template': templates.EditorTemplate,
    'title':false,
    'fieldClass': RadioTemplateStyle.field,
    'namespaceClass':RadioTemplateStyle.namespace
};


/** WEBPACK FOOTER **
 ** ./src/templates/RadioTemplate.js
 **/